<lms-breadcrumb [crumbs]="crumbList"></lms-breadcrumb>
<mat-tab-group
  class="tab-group"
  *lmsProfileGuard="'kepler.edit'"
  #tabGroup
  animationDuration="0ms"
  disableRipple="true"
  (selectedTabChange)="setTab($event)"
>
  <mat-tab label="information">
    <ng-template mat-tab-label>
      <div data-testid="keplerInformationTab">{{ 'kepler.tabs.information' | translate }}</div>
    </ng-template>
    <ng-template matTabContent>
      <lms-kepler-editor [client]="client" [keplerMatch]="match" (submit)="updateMatch($event)"> </lms-kepler-editor>
    </ng-template>
  </mat-tab>

  <mat-tab label="notifications">
    <ng-template mat-tab-label>
      <div data-testid="keplerInformationTab">{{ 'kepler.tabs.notifications' | translate }}</div>
    </ng-template>
    <ng-template matTabContent>
      <lms-kepler-notification-list [match]="match"></lms-kepler-notification-list>
    </ng-template>
  </mat-tab>

  <mat-tab label="players">
    <ng-template mat-tab-label>
      <div data-testid="keplerInformationTab">{{ 'kepler.tabs.players' | translate }}</div>
    </ng-template>
    <ng-template matTabContent>
      <lms-kepler-player-list
        [match]="match"
        [options]="{ filters: filters }"
        (uploadPlayers)="updateMatch($event)"
      ></lms-kepler-player-list>
    </ng-template>
  </mat-tab>

  <mat-tab label="kpis">
    <ng-template mat-tab-label>
      <div data-testid="keplerInformationTab" class="position-relative">
        <div *ngIf="match.shouldDisplayObjectives && getObjectivesDeadLineDays() < 1" class="badge__circle">
          <div class="badge__circle--icon">!</div>
        </div>
        {{ 'kepler.tabs.kpis' | translate }}
      </div>
    </ng-template>
    <ng-template matTabContent>
      <lms-kepler-goal-list
        [match]="match"
        [listOptions]="{ filters: filters }"
        (uploadKpis)="updateMatch($event)"
      ></lms-kepler-goal-list>
    </ng-template>
  </mat-tab>

  <mat-tab label="progress">
    <ng-template mat-tab-label>
      <div data-testid="keplerInformationTab">{{ 'kepler.tabs.progress' | translate }}</div>
    </ng-template>
    <ng-template matTabContent>
      <lms-kepler-progress-list [options]="{ filters: filters }"></lms-kepler-progress-list>
    </ng-template>
  </mat-tab>

  <mat-tab label="ranking">
    <ng-template mat-tab-label>
      <div data-testid="keplerInformationTab">{{ 'kepler.tabs.ranking' | translate }}</div>
    </ng-template>
    <ng-template matTabContent>
      <lms-kepler-ranking-list [options]="{ filters: filters }" [match]="match"></lms-kepler-ranking-list>
    </ng-template>
  </mat-tab>
</mat-tab-group>

<div class="gl-context-menu__position" [ngClass]="{ hidden: actions?.children?.length === 0 }">
  <lms-button-actions>
    <div #actions class="gl-context-menu__options">
      <ng-container *lmsProfileGuard="'kepler.downloadSupervisorsReport'">
        <span *ngIf="match.playerCount" class="gl-context-menu__options--item" (click)="downloadSupervisorsReport()">
          {{ 'kepler.downloadSupervisorsReport' | translate }}
        </span>
      </ng-container>
      <ng-container *lmsProfileGuard="'kepler.delete'">
        <span *ngIf="!match.playerCount" class="gl-context-menu__options--item alert" (click)="deleteMatch()">
          {{ 'actions.delete' | translate }}
        </span>
      </ng-container>
    </div>
  </lms-button-actions>
</div>
